import React from 'react'
import { Transaction } from '@web/walter-lib/stream/types'
import { FormattedHTMLMessage } from '@web/walter-ui-kit'
import { logPosthogEvent } from '@walter/shared/utils/posthog'
import { rpPosthogEvents } from '@walter/shared/constants/posthog'
import TxNotificationIcon from '../../TxNotificationIcon'
import { ProcessedNotificationData } from '../types'
import AmountContent from '../AmountContent'
import { getErrorNotification } from '../notifications'
import { lang } from './lang'
import { generateUrl } from '~utils/navigation/generateUrl'
import { Routes } from '~constants/routes'

const getTransactionFromTo = (data: Transaction) => {
    const fromCurrency = data.native?.currency
    const fromAmount = data.native?.amount

    const linkedTransaction = data.linked_transactions?.find(item => item?.operation_id === data.operation_id)
    const toCurrency = data.meta?.instant_exchange?.to_currency ?? linkedTransaction?.native?.currency
    const toAmount = data.meta?.instant_exchange?.to_amount ?? linkedTransaction?.native?.amount

    return { fromCurrency, fromAmount, toCurrency, toAmount }
}

export const processSwap = (data: Transaction): ProcessedNotificationData | null => {
    /*
     * Convert transaction
     * CHAIN_SWITCH_TO - to currency
     * CHAIN_SWITCH_FROM - from currency
     * INSTANT_EXCHANGE - exchange funds between different wallets
     */

    /**
     * Currently only success and failed statuses processed
     * Pending and created statuses are processed as "pending" one-time notification triggered on REST request
     */
    if (
        data.subtype === 'CHAIN_SWITCH_TO' ||
        data.subtype === 'INSTANT_EXCHANGE' ||
        data.subtype === 'CHAIN_SWITCH_FROM'
    ) {
        const { fromAmount, fromCurrency, toAmount, toCurrency } = getTransactionFromTo(data)

        logPosthogEvent(rpPosthogEvents.swapStatus, {
            from_amount: fromAmount,
            from_currency: fromCurrency,
            to_amount: toAmount,
            to_currency: toCurrency,
            source: 'wallet',
            success: data.status === 'SUCCESS',
        })

        if (data.status === 'SUCCESS') {
            return {
                icon: <TxNotificationIcon status="SUCCESS" />,
                title: <FormattedHTMLMessage {...lang.successTitle} />,
                content: (
                    <AmountContent
                        title={lang.successContent}
                        sign={1}
                        amount={toAmount || '0'}
                        currencyCode={toCurrency || ''}
                    />
                ),
                status: 'success',
                dataPointer: 'swap_success_notification',
            }
        }

        if (data.status === 'FAILED') {
            return getErrorNotification({
                title: lang.errorTitle,
                content: lang.errorContent,
                buttonText: lang.errorButton,
                buttonLink: generateUrl({
                    route: Routes.swap,
                    fromCurrency,
                    toCurrency,
                }),
                dataPointer: 'swap_failed_notification',
            })
        }
    }

    return null
}
